import { render } from "./SuccessCreateProjectModal.molecules.vue?vue&type=template&id=e9264ae8&ts=true"
import script from "./SuccessCreateProjectModal.molecules.vue?vue&type=script&lang=ts"
export * from "./SuccessCreateProjectModal.molecules.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__